import React from 'react'
import AddProductCatalouge from '../components/AddProducts/AddProductCatalouge'
import EditProductCatalougeComp from '../components/EditProductCatalouge'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import { ROUTES } from '../shared/constants'

function EditProductCatalouge() {
  return (
    <Layout heading="Product Catalogue" heading2="Edit" url1={ROUTES.PRODUCT_CATALOGUE} none>
      <div style={{ marginLeft: '18px', marginRight: '15px' }}>
        <HeaderTabLayout heading="Edit Product Catalogue" content={<EditProductCatalougeComp />} />
      </div>
    </Layout>
  )
}

export default EditProductCatalouge
